import React, { lazy, Suspense, memo } from "react";
import Loading from "components/shared-components/Loading";
import Views from "views";
import { themeStore } from "stores/themeStore.store";
import { authStore } from "stores/auth.store";

const AppLayout = lazy(() => import("./AppLayout"));
const AuthLayout = lazy(() => import("./AuthLayout"));

const Layouts = () => {
  const token = authStore.getState().token;

  //   const blankLayout = useSelector((state) => state.theme.blankLayout);
  //   const direction = useSelector((state) => state.theme.direction);
  //   const navType = useSelector((state) => state.theme.navType);
  const { navCollapsed, navType, direction, blankLayout } = themeStore();

  const Layout = token && !blankLayout ? AppLayout : AuthLayout;

  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Layout
        direction={direction}
        navType={navType}
        navCollapsed={navCollapsed}
      >
        <Views />
      </Layout>
    </Suspense>
  );
};

export default memo(Layouts);
